<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="true" />
    <v-snackbar v-model="snackbar" :multi-line="false" :timeout="6000" :location="'top'" :vertical="false">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Close</v-btn>         
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="pt-6">
          <span class="text-h5"> {{ formdata.Id ? 'Update' : 'New' }} Booking Programs</span>
        </v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-layout>
                <v-col col="8" sm="8" md="8">
                  <!-- <v-text-field v-model="formdata.ShortDescription" :rules="shortDescriptionRules" :counter="10" label="Short Description (i.e seen by sales member)" placeholder="Place holder"></v-text-field> -->
                  <v-text-field v-model="formdata.ShortDescription" :disabled="formdata.Id != undefined" maxLength="9"
                    :counter="9" label="Short Description (i.e seen by sales member)" placeholder="Place holder"
                    variant="underlined" class="ta-bookingprogram-shortdescription" color="primary" />
                  <span class="text-red" v-if="invalidInputSD">* Short Description is required</span>
                </v-col>
              </v-layout>
              <v-layout>
                <v-col col="12" sm="12" md="12">
                  <v-text-field v-model="formdata.LongDescription" maxLength="50" :counter="50" label="Long Description"
                    placeholder="Place holder" class="ta-bookingprogram-longdescription" variant="underlined"
                    color="primary" />
                  <span class="text-red" v-if="invalidInputLD">* Long Description is required</span>
                  <!-- <v-text-field v-model="formdata.LongDescription" :rules="longDescriptionRules" :counter="50" label="Long Description" placeholder="Place holder"></v-text-field> -->
                </v-col>

              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-layout wrap>
            <v-col col="12" sm="12" md="12">

              <v-btn :class="'ta-bookingprogram-savesettings' + 'mr-10'" variant="elevated" elevation="8"
                density="comfortable" rounded="xs" color="success" @click="addAppSettings" :disabled="!valid">
                {{ formdata.Id ? 'Update' : 'Create' }}
              </v-btn>
              <v-btn :class="'ta-bookingprogram-cancelsettings'" size="small" variant="outlined" color="dark"
                @click="cancelDialog">Cancel</v-btn>
            </v-col>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card prepend-icon="mdi-cog" style="padding-right: 0px;">
      <template v-slot:title>
        <h3 class="text-black">Settings</h3>
      </template>
    </v-card>

    <v-divider />

    <v-row class="padding_left_20">
      <v-col col="12">
        <v-card>
          <v-card-title class="padding_bottom_0">
            <h3 class="text-black">Booking Programs</h3>
            <!-- v-bind:label="expanded?'on':'off'" -->
            <v-switch color="green" style="z-index: 1;" :class="'swtich ' + 'ta-bookingprogram-switchsettingstatus'"
              v-on:update:model-value="updateBookingProgramStatus()" v-model="bookingProgramSettingStatus.Value"
              v-bind:label="bookingProgramSettingStatus.Value ? 'on' : 'off'" />
          </v-card-title>
          <v-card-text class="padding_bottom_0">

            <p class="subheading_FontSize20_padding-top10">
              <small>Booking Programs will provide optional or required option to select from in AGRIS Sales App</small>
            </p>

            <div class="position_right" v-if="bookingProgramSettingStatus.Value">
              <v-btn :class="'ta-bookingprogram-createnew'" size="small" variant="outlined" color="success"
                @click="openBookingProgramCreationDailog()">Create New Program</v-btn>
            </div>
            <span></span>
          </v-card-text>

          <v-card v-if="bookingProgramSettingStatus.Value">
            <v-data-table style="height:425px;overflow: auto;" :headers="headers" :items="bookingProgramSlots"
              class="elevation-1" :hide-default-footer="true">
              <template v-slot:item="props">
                <tr v-if="bookingProgramSlots.length">
                  <td
                    :class="'text-xs-left hidden-xs-only ' + 'ta-bookingprogram-' + props.item.Name.replaceAll(' ', '-')"
                    style="font-size: 14px;font-weight: 500;color:#3b3b3b">
                    {{ props.item.Name }}</td>
                  <td
                    :class="'text-xs-left hidden-xs-only ' + 'ta-bookingprogram-' + props.item.Value.replaceAll(' ', '-')"
                    style="font-size: 14px;font-weight: 500;color:#3b3b3b">
                    {{ props.item.Value }}</td>
                  <td class="justify-center layout px-0">

                    <v-icon :class="'mr-2' + ' ta-bookingprogram-edit-' + props.item.Name.replaceAll(' ', '-')"
                      color="warning" @click="openBookingProgramCreationDailog(props.item)">mdi-pencil</v-icon>
                    <v-icon :class="'ta-bookingprogram-delete-' + props.item.Name.replaceAll(' ', '-')" color="error"
                      @click="deleteItem(props.item)">mdi-delete</v-icon>

                  </td>
                </tr>
              </template>
              <template v-slot:no-data v-if="true">There are no booking program yet.</template>
              <template v-slot:bottom></template>
            </v-data-table>

            <v-card-actions v-if="bookingProgramSlots.length">
              <v-row wrap>
                <v-col x col="9" sm="9" class="py-2">
                  <p class="text-left subheading_FontSize20_padding-top10">
                    <small>Are these deals optional or required during the booking process?</small>
                  </p>
                  <div class="text-left ">
                    <v-btn-toggle elevation="4" density="compact" v-model="bookingProcess.Value">

                      <v-btn value="Required" @click="selectBookingProcess('Required')" elevation="12" rounded="sm"
                        :class="btnRequiredClass" :color="btnRequired" density="compact"
                        style="margin-right: 1px;">Required</v-btn>
                      <v-btn value="Optional" @click="selectBookingProcess('Optional')" elevation="12"
                        :class="btnOptionalClass" :color="btnOptional" density="compact" rounded="sm">Optional</v-btn>
                    </v-btn-toggle>
                  </div>
                </v-col>
                <v-col style="padding-top: 6%;" class="text-center">
                  <v-btn :class="'ta-bookingprogram-savesettings'" variant="elevated" elevation="8" rounded="xs"
                    color="success" @click="saveBookingProcess()">Save</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            <br>
            <br>
          </v-card>

        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script >
// eslint-disable-next-line
/* eslint-disable */
import DataService from "@/services/data-service";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const dataService = new DataService();
const CurrentAppSettings = "BookingProgramSettings";

class AppSettings {
  constructor(_type = "BookingProgramSettings", _name = "", _value = "") {
    this.Type = _type;
    this.Name = _name;
    this.Value = _value;
    this.Id = "";
  }
  Id;
  Name;
  Value;
  Type;
}

export default {
  name: "settings",
  data: () => ({
    snackbar: false,
    snackbarText: "",
    valid: false,
    invalidInputSD: false,
    invalidInputLD: false,
    btnRequired: "",
    btnOptional: "success",
    btnRequiredClass: "ta-bookingprogram-markrequired  black--text",
    btnOptionalClass: "ta-bookingprogram-markoptional  white--text",
    shortDescriptionRules: [
      (v) => !!v || "Short Description is required",
      (v) =>
        v.length <= 10 || "Short Description must be less than 10 characters",
      (v) => !!v.trim() || "Invalid",
    ],
    longDescriptionRules: [
      (v) => !!v || "Long Description is required",
      (v) =>
        v.length <= 50 || "Long Description must be less than 50 characters",
    ],
    dialog: false,
    formdata: {
      ShortDescription: "",
      LongDescription: "",
    },
    bookingProgramSettingStatus: {},
    bookingProcess: {},
    bookingProgramSlots: [],
    expanded: 0,
    users: [],
    isLoading: false,
    headers: [
      { title: "Short Description", value: "Name", key: "Name", width: "15%", sortable: false },
      { title: "Long Description", value: "Value", Key: "Value", width: "75%", sortable: false },
      { title: 'Actions', value: "", Key: "actions", width: "5%", sortable: false },
    ],
  }),
  created() {
    this.initilize();
  },
  components: {
    Loading,
  },
  methods: {
    openBookingProgramCreationDailog(item) {
      this.formdata = {
        ShortDescription: "",
        LongDescription: "",
      };
      if (item) {
        this.formdata.ShortDescription = item.Name;
        this.formdata.LongDescription = item.Value;
        this.formdata.Id = item.Id;
      }
      this.dialog = true;
    },
    addAppSettings() {
      this.invalidInputSD = false;
      this.invalidInputLD = false;

      if (
        !this.formdata.ShortDescription.trim() &&
        !this.formdata.LongDescription.trim()
      )
        return (this.invalidInputSD = true), (this.invalidInputLD = true);

      if (!this.formdata.ShortDescription.trim())
        return (this.invalidInputSD = true);

      if (!this.formdata.LongDescription.trim())
        return (this.invalidInputLD = true);

      if (this.formdata.Id) {
        let index = this.bookingProgramSlots.findIndex(
          (x) => x.Id == this.formdata.Id
        );
        this.bookingProgramSlots[index].Name = this.formdata.ShortDescription;
        this.bookingProgramSlots[index].Value = this.formdata.LongDescription;
        this.saveBookingProgram(this.bookingProgramSlots[index]);
      } else {
        let bookingSlot = Object.assign(new AppSettings(), {
          Id: "",
          Name: this.formdata.ShortDescription,
          Value: this.formdata.LongDescription,
        });
        this.saveBookingProgram(bookingSlot);
      }
    },

    cancelDialog() {
      this.dialog = false;
      this.invalidInputSD = false;
      this.invalidInputLD = false;
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this App Settings?")) {
        let index = this.bookingProgramSlots.findIndex((x) => x.Id == item.Id);
        if (index !== -1) {
          this.DeleteAppSettingById(item.Id);
        }
      }
    },
    initilize() {
      this.isLoading = true;
      this.GetAppSettings(true);
    },
    async GetAppSettings(onload = false) {
      if (onload == true) {
        this.bookingProgramSettingStatus = {};
        this.bookingProcess = {};
      }
      this.bookingProgramSlots = [];

      try {
        let response = await dataService.GetAppSettingsByType(
          CurrentAppSettings
        );
        this.isLoading = false;
        if (response && !response.length) {
          response.push(
            new AppSettings(
              "BookingProgramSettings",
              "BookingProgramSettingStatus",
              "false"
            )
          );
          response.push(
            new AppSettings(
              "BookingProgramSettings",
              "BookingProcess",
              "Optional"
            )
          );
        }

        if (response && response.length) {
          if (onload == true) {
            this.bookingProgramSettingStatus = response.find(
              (x) => x.Name == "BookingProgramSettingStatus"
            );
            if (!this.bookingProgramSettingStatus) {
              this.bookingProgramSettingStatus = new AppSettings(
                "BookingProgramSettings",
                "BookingProgramSettingStatus",
                "false"
              );
            }
            if (this.bookingProgramSettingStatus.Value == "true")
              this.bookingProgramSettingStatus.Value = true;
            else this.bookingProgramSettingStatus.Value = false;

            this.bookingProcess = response.find(
              (x) => x.Name == "BookingProcess"
            );
            if (!this.bookingProcess) {
              new AppSettings(
                "BookingProgramSettings",
                "BookingProcess",
                "Optional"
              );
            }
            this.selectBookingProcess(this.bookingProcess.Value);
          }
          this.bookingProgramSlots =
            response.filter(
              (x) =>
                x.Name != "BookingProgramSettingStatus" &&
                x.Name != "BookingProcess"
            ) || [];
          if (!this.bookingProgramSlots.length) {
            this.bookingProcess.Value = "Optional";
            this.selectBookingProcess(this.bookingProcess.Value);
            this.saveBookingProcess();
          }
        }
      } catch (ex) {
        this.isLoading = false;
      }

      // dataService.GetAppSettingsByType(CurrentAppSettings).then((response) => {
      //   this.settinglist = response;
      //   this.isLoading = false;
      //   if (response && !response.length) {
      //     response.push(
      //       new AppSettings(
      //         "BookingProgramSettings",
      //         "BookingProgramSettingStatus",
      //         "false"
      //       )
      //     );
      //     response.push(
      //       new AppSettings(
      //         "BookingProgramSettings",
      //         "BookingProcess",
      //         "Optional"
      //       )
      //     );
      //   }
      //   if (response && response.length) {
      //     if (onload == true) {
      //       this.bookingProgramSettingStatus = response.find(
      //         (x) => x.Name == "BookingProgramSettingStatus"
      //       );
      //       if (this.bookingProgramSettingStatus) {
      //         if (this.bookingProgramSettingStatus.Value == "true")
      //           this.bookingProgramSettingStatus.Value = true;
      //         else this.bookingProgramSettingStatus.Value = false;
      //       }

      //       this.bookingProcess = response.find(
      //         (x) => x.Name == "BookingProcess"
      //       );

      //       if (this.bookingProcess) {
      //         this.selectBookingProcess(this.bookingProcess.Value);
      //       }
      //     }

      //     this.bookingProgramSlots =
      //       response.filter(
      //         (x) =>
      //           x.Name != "BookingProgramSettingStatus" &&
      //           x.Name != "BookingProcess"
      //       ) || [];
      //     if (!this.bookingProgramSlots.length) {
      //       this.bookingProcess.Value = "Optional";
      //       this.selectBookingProcess(this.bookingProcess.Value);
      //       this.saveBookingProcess();
      //     }
      //   }
      // });
    },
    updateBookingProgramStatus() {
      this.isLoading = true;
      let data = [];
      data.push(this.bookingProgramSettingStatus);
      dataService
        .SaveAppSettings(data)
        .then((response) => {
          this.snackbar = true;
          this.snackbarText = "Settings saved successfully";
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          this.snackbar = true;
          this.snackbarText = "Settings saved failed";
        });
    },

    saveBookingProcess() {
      this.isLoading = true;
      let data = [];
      data.push(this.bookingProcess);
      dataService
        .SaveAppSettings(data)
        .then((response) => {
          this.snackbar = true;
          this.snackbarText = "Settings saved successfully";
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          this.snackbar = true;
          this.snackbarText = "Settings saved failed";
        });
    },

    saveBookingProgram(bookingProgramSlot) {
      this.isLoading = true;
      let data = [];
      data.push(bookingProgramSlot);
      dataService
        .SaveAppSettings(data)
        .then((response) => {
          this.dialog = false;
          this.snackbar = true;
          this.snackbarText = "Settings saved successfully";
          this.GetAppSettings();
        })
        .catch((e) => {
          let message = "Settings saved failed";
          if (e == "Name is already exists for this tenant.") {
            message = "Short description is already exist";
          }

          this.isLoading = false;
          this.snackbar = true;
          this.snackbarText = message;
        });
    },

    DeleteAppSettingById(id) {
      dataService
        .DeleteAppSettingById(id)
        .then((response) => {
          this.snackbar = true;
          this.snackbarText = "Settings removed successfully";
          this.GetAppSettings();
        })
        .catch((e) => {
          this.snackbar = true;
          this.snackbarText = "Settings removed failed";
        });
    },

    selectBookingProcess(val) {
      if (val == "Required") {
        this.btnRequired = "success";
        this.btnOptional = "";

        this.btnRequiredClass = "ta-bookingprogram-markrequired  white--text";
        this.btnOptionalClass = "ta-bookingprogram-markoptional  black--text";
      } else if (val == "Optional") {
        this.btnRequired = "";
        this.btnOptional = "success";

        this.btnRequiredClass = "ta-bookingprogram-markrequired black--text";
        this.btnOptionalClass = "ta-bookingprogram-markoptional  white--text";
      }
      this.bookingProcess.Value = val;
    },
  },
};
</script>

<style>
.subheading {
  text-align: left;
  font-size: 20px;
  font-weight: 500;
}

.subheading_FontSize20_padding-top10 {
  padding-top: 10px;
  text-align: left;
  font-size: 20px;
  font-weight: 500;
}

.padding_left_20 {
  padding-left: 0px;
}

.padding_10 {
  padding: 10px;
}

.v-list {
  height: 400px;
  overflow-y: auto;
}

.text_right {
  text-align: right;
}

.position_right {
  right: 140px !important;
  position: absolute !important;
  top: 7px !important;
}

.v-expansion-panel__header {
  background-color: white;
}

.swtich {
  position: absolute;
  top: -8px;
  right: 57px;
  z-index: 1000;
}

.padding_bottom_0 {
  padding-bottom: 0px;
}

.v-table--density-default>.v-table__wrapper>table>tbody>tr>th,
.v-table--density-default>.v-table__wrapper>table>tfoot>tr>th,
.v-table--density-default>.v-table__wrapper>table>thead>tr>th {
  width: 15%;
  font-size: smaller;
  font-weight: 500;
  color: gray;
}
</style>
